import { createContext, useContext, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";

// Api
import { useGetListCustomer } from "api/buyer-match/query";
import { useGetListPropertyCategoriesComplete } from "api/common/query";
import { useGetCountListingBuyerMatch } from "api/buyer-match/query";

export const BuyerMatchContext = createContext();

const _limit = 50;

export const BuyerMatchProvider = ({ children }) => {
  const location = useLocation();

  const [isOpenDetailBuyer, setIsOpenDetailBuyer] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const isListArchived = useMemo(() => location.pathname.includes("list-archived"), [location.pathname]);
  const [listCustomerParams, setListCustomerParams] = useState({
    is_archive: isListArchived,
    page: 1,
    _limit: _limit
  });

  const {
    data: listPropertyCategories,
    isLoading: isLoadingListPropertyCategories,
  } = useGetListPropertyCategoriesComplete({ page: 1, _limit: _limit });

  const {
    data: listCustomerActive,
    refetch: refetchListCustomerActive,
  } = useGetListCustomer({ params: {is_archive: false} });
  
  const {
    data: listCustomer,
    isLoading: isLoadingListCustomer,
    refetch: refetchListCustomer,
  } = useGetListCustomer({ params: listCustomerParams });

  const {
    data: countListingBuyerMatch,
  } = useGetCountListingBuyerMatch({ id: selectedLeadId, enabled: !!selectedLeadId });

  const countData = useMemo(() => {
    const totalItem = listCustomer?.headers?.["x-total"] ?? 0;

    return totalItem;
  }, [listCustomer]);

  const totalPage = useMemo(() => {
    const totalItem = listCustomer?.headers?.["x-total"] ?? 0;

    const totalPages = Math.ceil(totalItem / _limit);
    return totalPages;
  }, [listCustomer]);

  return (
    <BuyerMatchContext.Provider
      value={{
        listPropertyCategories,
        isLoadingListPropertyCategories,
        listCustomer,
        isLoadingListCustomer,
        refetchListCustomer: () => {
          refetchListCustomerActive();
          refetchListCustomer();
        },
        isOpenDetailBuyer,
        selectedLeadId,
        setIsOpenDetailBuyer,
        setSelectedLeadId,
        setListCustomerParams,
        listCustomerParams,
        countData,
        totalPage,
        listCustomerActive: listCustomerActive?.data?.data,
        countListingBuyerMatch: countListingBuyerMatch?.data?.data,
      }}
    >
      {children}
    </BuyerMatchContext.Provider>
  );
};

export const useBuyerMatchCtx = () => {
  const ctx = useContext(BuyerMatchContext);

  if (!ctx) {
    throw new Error(
      "useBuyerMatchCtx must be used within the BuyerMatchProvider"
    );
  }

  return ctx;
};
